import React from "react";
import "./ComponentLoading.css";

function ComponentLoading () {

    return (
        <div className="loadingDiv">
            <i className="material-icons cog cog-top spin-forward">
                settings
            </i>
            <br />
            <i className="material-icons cog spin-forward">
                settings
            </i>
            <i className="material-icons cog spin-reverse cog-middle">
                settings
            </i>
        </div>
    );

}
export default ComponentLoading;
